import HeaderDrawer from "./HeaderDrawer";
// import { domain, headerDomain } from "../../constants/generalConstant";
// import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import logo from "../../assets/srlogo.jpg";
import { useMediaQuery } from "react-responsive";
import { Link, useNavigate } from "react-router-dom";
// import { Box, Button, Typography } from "@mui/material";
// import grl from "../../assets/grl.jpg";

const headerData = [
  { title: "Home", url: "/", id: 1 },
  // { title: "Login", url: "/login", id: 2 },
  // { title: "Ship", url: "/user-create-shipment", id: 3 },

  { title: "Track", url: "/track-parcel", id: 4 },
  { title: "About Us", url: "/about-us", id: 5 },
  { title: "Contact Us", url: "/contact-us", id: 6 },
  { title: "Services", url: "/service", id: 7 },
];

export default function Header() {
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 1224px)",
  });
  const isBigScreen = useMediaQuery({ query: "(min-width: 1824px)" });
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 768px)" }); //1224px
  const isPortrait = useMediaQuery({ query: "(orientation: portrait)" });
  const isRetina = useMediaQuery({ query: "(min-resolution: 2dppx)" });

  if (isTabletOrMobile) {
    console.log("tab or mobile");
  } else if (isDesktopOrLaptop) {
    console.log("desktop or laptop");
  } else if (isBigScreen) {
    console.log("big screen");
  } else if (isPortrait) {
    console.log("portrait");
  } else if (isRetina) {
    console.log("retina");
  }

  const mobileHeaderNav = <HeaderDrawer />;
  const desktopHeaderNav = (
    <ul className="flex  text-white   justify-around  items-center  space-x-[1.5rem]">
      {headerData.map((data) => (
        <li
          key={data.id}
          className="font-medium   tracking-wide  hover:text-yellow-500  hover:underline  "
        >
          <Link to={data.url}>{data.title}</Link>
        </li>
      ))}
    </ul>
  );

  const navigate = useNavigate();

  // const handleClick = (url) => {
  // 	if (url === "/") {
  // 		gotoHome();
  // 	} else {
  // 		navigate(url);
  // 	}
  // };

  const gotoHome = (url) => {
    navigate(url);
  };

  const content = (
    <header
      style={{ zIndex: 50, position: "sticky", top: 0 }}
      className="      min-w-full    sticky   top-0"
    >
      <div
        className="  h-[4.5rem] px-[0.5rem] md:px-[3.5rem]  z-50  flex  justify-between  items-center bg-red-700 text-[#f1c24e] "
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          background: "#034052",
          color: "#f1c24e",
          height: "4.5rem",
          px: { xs: "0.5rem", md: "3.5rem" },

          zIndex: 50,
        }}
      >
        {/* <img src={grl} alt="Logo" style={{ width: "10%", height: "auto" }} /> */}
        <button
          onClick={() => gotoHome("/")}
          className="   h-[3rem]  flex justify-center  items-center overflow-hidden     gap-0"
        >
          <img
            src={logo}
            alt="logo"
            className="w-[6rem]  pl-[0.3rem]   rounded-full     md:pl-0"
          />
          {/* <span className=" min-w-fit  hidden   md:inline-block font-semibold  text-gray-200     text-[0.75rem]  capitalize">
						shippers route
					</span>
					<div className=" min-w-fit  md:hidden  flex flex-col   font-semibold  text-gray-200     text-[0.6rem]  capitalize">
						<span className="inline-block">shippers</span>
						{/* <hr className="bg-yellow-400  text-yellow-600" /> */}
          {/* <span className="inline-block">route</span>
					</div> */}
          {/* <LocalShippingIcon
					sx={{
						display: "inline-block",
						mt: "0.4rem",
						ml: "0.2rem",
					}}
				/> */}
        </button>
        {isTabletOrMobile ? mobileHeaderNav : desktopHeaderNav}
      </div>
    </header>
  );

  return content;
}
